import iconFolder from '../../../../img/icons/folder.svg';
import iconPdf from '../../../../img/icons/pdf.svg';
import iconTxt from '../../../../img/icons/txt.svg';
import iconPpt from '../../../../img/icons/ppt.svg';
import iconDoc from '../../../../img/icons/doc.svg';
import iconXls from '../../../../img/icons/xls.svg';
import iconFile from '../../../../img/icons/file.svg';

export const iconSet = {
  folder: iconFolder,
  pdf: iconPdf,
  file: iconFile,
  doc: iconDoc,
  ppt: iconPpt,
  xls: iconXls,
  txt: iconTxt,
};

const iconsByMimeType = {
  'application/pdf': iconSet.pdf,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': iconSet.doc,
  'application/msword': iconSet.doc,
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': iconSet.ppt,
  'application/vnd.ms-powerpoint': iconSet.ppt,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': iconSet.xls,
  'application/vnd.ms-excel': iconSet.xls,
  'text/plain': iconSet.txt,
};

export const getIconByMimetype = (mimetype) => iconsByMimeType[mimetype];
